import styled from 'styled-components';

export const SummaryText = styled.span`
  word-break: break-word;
  white-space: pre-line;
  overflow-wrap: break-word;
  display: block;
  font-family: 'Roboto', sans-serif;
  font-size: clamp(11px, 0.9vw, 14px);
`;
